import React from 'react';

import { useTitle } from '@admin/hooks/use_title';

import { TicketGroupingsPanel } from './ticket_groupings_panel';
import { TicketGroupsPanel } from './ticket_groups_panel';

export const TicketManagement: React.FC = () => {
  useTitle('Ticket Management');
  return (
    <>
      <TicketGroupsPanel />
      <TicketGroupingsPanel />
    </>
  );
};
